// Get Smart Group
export const GET_SMART_GROUP_REQUEST = 'GET_SMART_GROUP_REQUEST';
export const GET_SMART_GROUP_DONE = 'GET_SMART_GROUP_DONE';
export const GET_SMART_GROUP_FAILED = 'GET_SMART_GROUP_FAILED';

// Update Smart Group
export const UPDATE_SMART_GROUP_REQUEST = 'UPDATE_SMART_GROUP_REQUEST';
export const UPDATE_SMART_GROUP_DONE = 'UPDATE_SMART_GROUP_DONE';
export const UPDATE_SMART_GROUP_FAILED = 'UPDATE_SMART_GROUP_FAILED';
export const UPDATE_SMART_GROUP_RESET = 'UPDATE_SMART_GROUP_RESET';